import { render, staticRenderFns } from "./splash-video.vue?vue&type=template&id=103770aa&"
import script from "./splash-video.vue?vue&type=script&lang=js&"
export * from "./splash-video.vue?vue&type=script&lang=js&"
import style0 from "./splash-video.vue?vue&type=style&index=0&id=103770aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports